import { z } from 'zod';

const applicantLeadFlagsTriggersSchema = z.object({
    schufaResolved: z.boolean().default(false),
});

export const LeadFlagsTriggersSchema = z
    .object({
        applicant1: applicantLeadFlagsTriggersSchema.default({ schufaResolved: false }),
        applicant2: applicantLeadFlagsTriggersSchema.default({ schufaResolved: false }),
        attributionResolved: z.boolean().default(false),
    })
    .default({});

export type LeadFlagsTriggers = z.infer<typeof LeadFlagsTriggersSchema>;
